import React, { ComponentProps } from 'react';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import {
  PageMembershipMatchingRulesReportsProps,
} from '../../../types/PageMembershipMatchingRuleReportsList.types';
import { ReportsList } from '../../../_lib/components/ReportsList/ReportsList';
import { ReportsListActionBar } from '../../../_lib/components/ReportsListActionBar/ReportsListActionBar';
import { useSonTranslation } from '../../../translation/useSonTranslation';

export function PageMembershipMatchingRulesReports(props: PageMembershipMatchingRulesReportsProps) {
  const { t } = useSonTranslation('PageMembershipMatchingRuleList');

  return (
    <>
      <ReportsListActionBar
        form={props.executeMatcher}
        heading={t('triggerMatcherExecution')}
        headline={t('interactions.executeMatcher.form.headline')}
        messageSuccess={t('interactions.executeMatcher.form.messageSuccess')}
        messageSending={t('interactions.executeMatcher.form.messageSending')}
        messageFail={t('interactions.executeMatcher.form.messageFail')}
        customErrorTypeMessages={{
          jobAlreadyInProgress: t('interactions.executeMatcher.form.status.jobAlreadyInProgress'),
        }}
        hintMessage={t('interactions.executeMatcher.form.hint')}
        checkBoxLabel={t('interactions.executeMatcher.form.checkBoxDryRun')}
      />
      <ReportsList {...props} />
    </>
  );
}

export const PageMembershipMatchingRulesReportsView = asFetchableView(PageMembershipMatchingRulesReports);
export type PageMembershipMatchingRulesReportsView = ComponentProps<typeof PageMembershipMatchingRulesReports>;
